import script from "./hardware.vue?vue&type=script&lang=ts&setup=true"
export * from "./hardware.vue?vue&type=script&lang=ts&setup=true"

import "./hardware.vue?vue&type=style&index=0&id=560c047a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560c047a"]])

export default __exports__